import { AppBar, Box, Divider, IconButton, InputBase, Toolbar, Typography, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as CatalogueIcon } from "assets/sidebar/enable/catalogue.svg";
import BreadCrumbComponent from "components/ui/BreadCrumb";
import Button from "components/ui/Button";
import { useCatalogSettingContext } from "context/CatalogSettingContext";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import { useGlobalContext } from "context/GlobalContext";
import { stubTrue } from "lodash";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const StyledButton = styled(Button)(({ theme, bgcolor }) => ({
  width: "100%",
  fontFamily: "Karla",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "21.5px",
  height: "41px",
  borderRadius: "5px",
  color: bgcolor ? bgcolor : "#ffffff",
  border: `1px solid ${bgcolor ? bgcolor : " #ffffff"} `,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: bgcolor ? bgcolor : "#ffffff",
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

export const CatalogSettingHeaderNew = ({ location }) => {
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [tempSearch, setTempSearch] = useState("");

  const { setDynamicFilterCount } = useGlobalContext();

  const catalogName = location?.state?.catalogName;
  const catalogNumber = location?.state?.catalogNumber;

  const catalogId = location?.state?.catalogId;
  const {
    setShareLinkOpen,
    userActivity,
    userReport,
    userCurrentPath,
    setTimeSpentCatalogOpen,
    setUploadDataModal,
    setSortModal,
    isRenewAccess,
    setRenewAccessModal,
    revokAccessModal,
    setRevokAccessModal,
    setUpdateClient,
    setIsEditClinet,
    serarch,
    setSerarch,
    activeTable,
  } = useCatalogSettingContext();

  const permission = usePermissions();
  // const hasViewMobileNumber = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Add Mobile No."), "view");
  // const hasAddMobileNumber = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Add Mobile No."), "add");
  // const hasViewUploadBulk = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Bulk Mobile No. List"), "view");
  // const hasAddUploadBulk = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Bulk Mobile No. List"), "add");
  // const hasViewCatalogReport = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog Setting", permission), "Catalog Report"), "view");
  // const hasViewRevokAccess = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Client Activity", permission), "Renew & Revoke Access"), "view");
  const hasAddRevokAccess = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Client Activity", permission), "Renew & Revoke Access"), "add");
 const hasViewRevokAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Miscellaneous Catalog"), "renew/revoke_access");
  const handlAddMobileModal = () => {
    setUpdateClient({});
    setIsEditClinet(false);
    setShareLinkOpen(true);
  };

  const handlTimeSpentCatalog = () => {
    setTimeSpentCatalogOpen(true);
  };

  const handleUploadDataModal = () => {
    setUploadDataModal(true);
  };

  const handlOnCatalogTimeSpent = () => {
    navigate(`Catalog-Report/${catalogId}`, { ...location });
  };

  const handleRenewAccess = () => {
    setRenewAccessModal(true);
  };

  const handleRevokAccess = () => {
    //  setRevokData(curData);
    setRevokAccessModal(true);
  };

  const handleSearch = () => {
    setSerarch(tempSearch);
    setDynamicFilterCount(false);
  };

  useEffect(() => {
    setTempSearch(serarch);
  }, [serarch]);

  useEffect(() => {
    if (tempSearch === "") {
      setSerarch("");
    }
  }, [tempSearch]);

  useEffect(() => {
    let isSession = location?.state?.isSession;
    let isClientReport = location?.state?.isClientReport;

    let newBreadcrumbs = [];
    newBreadcrumbs.push({
      name: isSession || isClientReport ? `Catalog - ${catalogNumber}` : `${activeTable} - ${catalogName}`,

      path: `/CatalogSetting/${catalogId}`,
    });

    if (Object.keys(userCurrentPath).length > 0) {
      newBreadcrumbs.push(userCurrentPath);
    }

    setBreadcrumbs(newBreadcrumbs);
  }, [userCurrentPath, activeTable]);

  return (
    <>
      <div style={{ height: "auto" }}>
        <div position="fixed" elevation={0} style={{ backgroundColor: "#000" }}>
          <Toolbar></Toolbar>
        </div>
      </div>
      <div style={{ height: "auto" }}>
        <div style={{ position: "sticky", zIndex: "1000", top: "70px", background: "black" }}>
          <Box
            sx={{
              border: "1px solid #000",
              display: "flex",
              justifyContent: "center",
              padding: "0px",
              paddingBottom: "10px",
              position: "sticky",
              zIndex: "999",
              top: "70px",
              backgroundColor: "black !important",
            }}
            maxWidth={"100%"}
          >
            <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "95.4%" }} />
          </Box>
        </div>
        <div style={{ height: "auto" }}>
          <Box className="child-header" sx={{ padding: "20px", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "20px", paddingRight: "20px" }}>
            <div className="child-header-sub">
              {
                <>
                  <IconButton sx={{ padding: "0px" }}>
                    <CatalogueIcon />
                  </IconButton>

                  {<BreadCrumbComponent breadcrumbs={breadcrumbs} />}
                </>
              }
            </div>
            {!userReport && (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="child-header-create-btn">
                  <StyledButton onClick={handlTimeSpentCatalog} disableRipple disableFocusRipple>
                    Total Time Spent on Catalog
                  </StyledButton>
                </div>
                <div className="child-header-sort">
                  <IconButton onClick={() => setSortModal(true)} disableRipple disableFocusRipple>
                    <Sort />
                  </IconButton>
                </div>
              </div>
            )}
            {!userActivity &&
              (isRenewAccess
                ? hasViewRevokAccess && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div className="child-header-create-btn">
                        <StyledButton disabled={!hasAddRevokAccess} bgcolor="#50C878" sx={{ width: "150px" }} onClick={handleRenewAccess}>
                          Renew Access
                        </StyledButton>
                      </div>
                    </div>
                  )
                : hasViewRevokAccess && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div className="child-header-create-btn">
                        <StyledButton disabled={!hasAddRevokAccess} bgcolor={"#E77B7B"} sx={{ width: "150px" }} onClick={handleRevokAccess}>
                          Revoke Access
                        </StyledButton>
                      </div>
                    </div>
                  ))}
            {userActivity && userReport && activeTable === "Links" && (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {false && (
                  <div className="child-header-create-btn-catalog-setting" style={{ paddingRight: true ? "" : "10px" }}>
                    <StyledButton onClick={handleUploadDataModal} disableRipple disableFocusRipple>
                      Upload Bulk List of Number
                    </StyledButton>
                  </div>
                )}
              </div>
            )}
          </Box>
        </div>
      </div>
    </>
  );
};
